/**
 * @ngdoc component
 * @name common.service:ItxLoaderFct
 * @description
 * Show and hide loader spinner adding and removig the class `md-loader-active` to the body through Jquery.
 */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxLoaderFct', ItxLoaderFct);

    function ItxLoaderFct() {
        var className = 'md-loader-active';
        return {
            show: function () {
                $('body').addClass(className);
            },
            hide: function () {
                $('body').removeClass(className);
            }
        };
    }

    /** Public */
    itxApp.common.ItxLoaderFct = ItxLoaderFct;

})(window.itxApp);
